(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/animations/assets/javascripts/animations/tweens/create-set-center-tween.js') >= 0) return;  svs.modules.push('/components/onboarding/animations/assets/javascripts/animations/tweens/create-set-center-tween.js');
"use strict";



const positions = svs.components.onboarding.animations.positions;

const createSetCenterTween = el => gsap.set(el, {
  x: positions.center
});
setGlobal('svs.components.onboarding.animations.tweens.createSetCenterTween', createSetCenterTween);

 })(window);